module.exports = __webpack_public_path__ + "img/hamburguesa.fdb953e7.png";